export default __webpack_public_path__ + "static/media/fv_products.217fdb50.svg";